import React from "react";
import { useNavigate } from "react-router-dom";
import s from "../components/Loading/LoadingInside.module.scss";

const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <div
            style={{
                minHeight: "70vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center"
            }}
        >
            <img
                src="/loader.gif"
                alt="Loading..."
                className={s.loaderGif}
            />
            <h1>404</h1>
            <h2>ページが見つかりません</h2>

            <p>
                お探しのページは存在しません。
            </p>

            <button
                onClick={() => navigate("/")}
            >
                ホームへ戻る
            </button>
        </div>
    );
};

export default NotFoundPage;